import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/User';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user = new User();
  constructor(private service: ApiService, private router: Router) { }

  ngOnInit(): void {
    if (localStorage.getItem('token')) {
      this.router.navigate(['/adminarea']);
    }
  }
  async login() {
    try {
      let result = await this.service.login(this.user);
      // console.log(result);
      localStorage.setItem('token', result.token);
      localStorage.setItem('user', JSON.stringify(result));
      this.router.navigate(['/adminarea']);
    } catch{
      console.error('unauthorized');
    }
  }
}
